<template>
  <footer class="app-footer">
    <div class="footer-inner">
      <div class="footer-top">
        <div class="footer-brand">
          <span class="footer-logo">digitly</span>
          <p class="footer-tagline">
            Websites and automation<br>for UK businesses.
          </p>
        </div>

        <div class="footer-links-grid">
          <div class="footer-col">
            <h4 class="footer-col-title">Company</h4>
            <router-link to="/" class="footer-link">Home</router-link>
            <router-link to="/about" class="footer-link">About</router-link>
            <router-link to="/services" class="footer-link">Services</router-link>
            <router-link to="/contact" class="footer-link">Contact</router-link>
          </div>

          <div class="footer-col">
            <h4 class="footer-col-title">Services</h4>
            <router-link to="/services/web-development" class="footer-link">Web Development</router-link>
            <router-link to="/services/ai-automation" class="footer-link">AI & Automation</router-link>
            <router-link to="/services/ecommerce" class="footer-link">E-Commerce</router-link>
            <router-link to="/services/maintenance" class="footer-link">Maintenance</router-link>
          </div>

          <div class="footer-col">
            <h4 class="footer-col-title">Get in touch</h4>
            <a href="mailto:georgepavlej@gmail.com" class="footer-link">georgepavlej@gmail.com</a>
            <a href="tel:+447897513276" class="footer-link">+44 78 9751 3276</a>
            <span class="footer-link footer-link-static">Mon – Sat, 9am – 6pm</span>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <p class="footer-copyright">&copy; {{ currentYear }} Digitly. All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.app-footer {
  background: var(--color-bg-alt);
  border-top: 1px solid var(--color-border);
}

.footer-inner {
  max-width: var(--container-max);
  margin: 0 auto;
  padding: 80px 24px 40px;
}

.footer-top {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 64px;
  margin-bottom: 64px;
}

.footer-logo {
  font-size: 1.375rem;
  font-weight: 800;
  color: var(--color-text);
  letter-spacing: -0.04em;
}

.footer-tagline {
  margin-top: 12px;
  font-size: 0.9375rem;
  line-height: 1.5;
  color: var(--color-text-secondary);
}

.footer-links-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
}

.footer-col {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.footer-col-title {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--color-text);
  margin-bottom: 6px;
}

.footer-link {
  font-size: 0.9375rem;
  color: var(--color-text-secondary);
  text-decoration: none;
  transition: color 0.15s ease;
}

.footer-link:hover {
  color: var(--color-text);
}

.footer-link-static {
  cursor: default;
}

.footer-link-static:hover {
  color: var(--color-text-secondary);
}

.footer-bottom {
  padding-top: 32px;
  border-top: 1px solid var(--color-border);
}

.footer-copyright {
  font-size: 0.8125rem;
  color: var(--color-text-tertiary);
}

@media (max-width: 768px) {
  .footer-top {
    grid-template-columns: 1fr;
    gap: 48px;
  }

  .footer-links-grid {
    grid-template-columns: 1fr 1fr;
    gap: 32px;
  }
}

@media (max-width: 480px) {
  .footer-links-grid {
    grid-template-columns: 1fr;
  }
}
</style>
